
import anime from 'animejs/lib/anime.es.js';

const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

// If a visitor prefers reduced motion
if ( reducedMotion )
{

}
else
{

}

function inViewport( elements, callback )
{
  // Initialize observer
  let observer = new IntersectionObserver((entries, observer) => {
    entries.forEach( entry => {
      // Check if the element is intersecting
      if(entry.isIntersecting)
      {
        if ( entry.target.classList.contains('animation-finished') ) {
          return;
        }
        callback( entry );
        entry.target.classList.add('animation-finished');
      }
    });
  }, {threshold: .25});
  // Add elements to the observer
  elements.forEach( el =>  observer.observe(el) );
}


// Loop trough all underlined block editor elements
document.querySelectorAll('span[style="text-decoration: underline;"]').forEach((item, i) => {

  // Add an extra span to make animation possible
  item.innerHTML = item.innerHTML + '<span class="underline" style="width:0px;"></span>';

  // When the underline is in the viewport
  inViewport( [item], ( entry ) => {

    // Perform an animation
    anime({
       targets: entry.target.querySelector('.underline'),
       width: 'calc(100% + 10px)',
       duration: 350,
       delay: 250,
       easing: 'easeOutCirc'
     });

  });

});

document.querySelectorAll('.hero--wide').forEach(function (group) {
  var col = group.querySelector('.wp-block-column.has-background');
  if (!col) return;

  if (col.dataset.plectrumsInjected === '1') return;
  col.dataset.plectrumsInjected = '1';

  var plectrumAnimated0 =
    '<svg class="shape-animated" data-delay="0" width="251" height="250" viewBox="0 0 251 250" xmlns="http://www.w3.org/2000/svg"><path d="M42.052 13.498c61.75-46.865 208.572 36.429 208.572 125.172 0 88.744-174.604 131.144-222.471 102.416-47.869-28.728-26.86-196.653 13.9-227.588Z" fill="#2a70b0" fill-rule="nonzero"/></svg>';

  var plectrumAnimated1 =
    '<svg class="shape-animated" data-delay="1000" width="251" height="250" viewBox="0 0 251 250" xmlns="http://www.w3.org/2000/svg"><path d="M42.052 13.498c61.75-46.865 208.572 36.429 208.572 125.172 0 88.744-174.604 131.144-222.471 102.416-47.869-28.728-26.86-196.653 13.9-227.588Z" fill="#2a70b0" fill-rule="nonzero"/></svg>';

  var plectrumBg =
    '<svg class="shape-background" width="251" height="250" viewBox="0 0 251 250" xmlns="http://www.w3.org/2000/svg"><path d="M42.052 13.498c61.75-46.865 208.572 36.429 208.572 125.172 0 88.744-174.604 131.144-222.471 102.416-47.869-28.728-26.86-196.653 13.9-227.588Z" fill="#2a70b0" fill-rule="nonzero"/></svg>';

  col.insertAdjacentHTML('beforeend', plectrumAnimated0 + plectrumAnimated1 + plectrumBg);

  anime({
    targets: col,
    scale: [0, 1],
    rotate: [-30, 0],
    duration: 500,
    easing: 'easeOutSine'
  });

  anime({
    targets: col.querySelectorAll(':scope > *:not(svg)'),
    opacity: [0, 1],
    translateY: [50, 0],
    duration: 350,
    delay: anime.stagger(75, { start: 250 }),
    easing: 'easeOutSine'
  });

  var loopAnims = [];

  function createLoop(el, keyframes, options, initialOffsetMs) {
    if (!el || !el.animate) return null;

    el.style.transformOrigin = '50% 50%';

    var anim = el.animate(keyframes, options);

    if (typeof initialOffsetMs === 'number' && initialOffsetMs > 0) {
      try {
        anim.currentTime = initialOffsetMs % options.duration;
      } catch (e) {}
    }
    return anim;
  }

  var bgEls = col.querySelectorAll(':scope > .shape-background');
  bgEls.forEach(function (el) {
    var a = createLoop(
      el,
      [{ transform: 'scale(1)' }, { transform: 'scale(1.05)' }, { transform: 'scale(1)' }],
      { duration: 10000, iterations: Infinity, easing: 'linear' },
      0
    );
    if (a) loopAnims.push(a);
  });

  var shEls = col.querySelectorAll(':scope > .shape-animated');
  shEls.forEach(function (el) {
    var delay = parseInt(el.getAttribute('data-delay') || '0', 10) || 0;
    var a = createLoop(
      el,
      [
        { transform: 'scale(1) rotate(0deg)' },
        { transform: 'scale(1.25) rotate(180deg)' },
        { transform: 'scale(1) rotate(360deg)' }
      ],
      { duration: 10000, iterations: Infinity, easing: 'linear' },
      delay
    );
    if (a) loopAnims.push(a);
  });

  var NORMAL = 1;
  var SLOW = 0.15;

  function tweenRate(toRate) {
    if (!loopAnims.length) return;

    var fromRate = loopAnims[0].playbackRate || NORMAL;
    var start = performance.now();
    var dur = 220;

    function tick(now) {
      var t = (now - start) / dur;
      if (t > 1) t = 1;

      var p = Math.sin((t * Math.PI) / 2);
      var rate = fromRate + (toRate - fromRate) * p;

      loopAnims.forEach(function (a) {
        a.playbackRate = rate;
      });

      if (t < 1) requestAnimationFrame(tick);
    }

    requestAnimationFrame(tick);
  }

  col.addEventListener('mouseenter', function () {
    tweenRate(SLOW);
  });

  col.addEventListener('mouseleave', function () {
    tweenRate(NORMAL);
  });
});



document.querySelectorAll('.wp-block-sowmedia-shape.is-shape-brand-icon').forEach((bloack, i) => {

  anime({
    targets: bloack.querySelectorAll('svg'),
    scale: [1, 1.2, 1],
    duration: 50000,
    loop: true,
    easing: 'linear'
  });


});

document.querySelectorAll('.wp-block-sowmedia-shape[class*="is-shape-plectrum"]').forEach((bloack, i) => {

  anime({
    targets: bloack.querySelectorAll('svg'),
    scale: [1, 1.2, 1],
    rotate: [0, 360],
    duration: 50000,
    loop: true,
    easing: 'linear'
  });


});

// document.querySelectorAll('.wp-block-group.alignfull, .wp-block-group.alignfull > .wp-block-columns, .wp-block-post-template, .wp-block-sowmedia-post-grid').forEach((block, i) => {

//     block.childNodes.forEach( (child, i ) => {

//       if ( child.style ) {

//         child.style.opacity = 0;

//       }

//     });

//      // When the columns is in the viewport
//     inViewport( [block], ( entry ) => {

//       // Perform an animation
//       anime({
//         targets: entry.target.children,
//         opacity: [0, 1],
//         translateY: [50, 0],
//         duration: 1000,
//         delay: anime.stagger(250),
//         easing: 'easeOutSine'
//       });

//     });


// });

// hero--plectrum + hover animation
document.querySelectorAll('.hero--plectrum').forEach((item, i) => {
  var image = item.querySelector('.wp-block-image, .wp-block-cover');
  if (!image) return;

  if (image.dataset.plectrumInit === '1') return;
  image.dataset.plectrumInit = '1';

  var plectrum =
    '<svg width="251" height="250" viewBox="0 0 251 250" xmlns="http://www.w3.org/2000/svg"><path d="M42.052 13.498c61.75-46.865 208.572 36.429 208.572 125.172 0 88.744-174.604 131.144-222.471 102.416-47.869-28.728-26.86-196.653 13.9-227.588Z" fill="#FFF" fill-rule="nonzero"/></svg>';
  image.innerHTML = plectrum + plectrum + plectrum + image.innerHTML;

  plectrum =
    '<svg class="plectrum-base--big" width="251" height="250" viewBox="0 0 251 250" xmlns="http://www.w3.org/2000/svg"><path d="M42.052 13.498c61.75-46.865 208.572 36.429 208.572 125.172 0 88.744-174.604 131.144-222.471 102.416-47.869-28.728-26.86-196.653 13.9-227.588Z" fill="#FFF" fill-rule="nonzero"/></svg>';
  image.innerHTML = plectrum + image.innerHTML;

  var DURATION = 20000;
  var STAGGER = 5000;

  var svgs = Array.from(image.querySelectorAll('svg'));

  svgs.forEach((svg, idx) => {
    var isBig = svg.classList.contains('plectrum-base--big');

    var endScale = isBig ? 6 : 4;
    var duration = isBig ? DURATION * 1.5 : DURATION; 

    anime({
      targets: svg,
      scale: [1, endScale],
      opacity: 0,
      rotate: 35,
      duration: duration,
      delay: idx * STAGGER,
      loop: true,
      easing: 'easeOutSine'
    });
  });

  var DURATION = 20000;
  var HOVER_DELAY = 0;

  function spawnHoverSingle() {
    var burst = document.createElement('div');
    burst.className = 'plectrum-hover-burst';
    burst.style.pointerEvents = 'none';

    burst.innerHTML =
      '<svg class="plectrum-burst-svg" width="251" height="250" viewBox="0 0 251 250" xmlns="http://www.w3.org/2000/svg"><path d="M42.052 13.498c61.75-46.865 208.572 36.429 208.572 125.172 0 88.744-174.604 131.144-222.471 102.416-47.869-28.728-26.86-196.653 13.9-227.588Z" fill="#FFF" fill-rule="nonzero"/></svg>';

    image.insertAdjacentElement('afterbegin', burst);

    var svg = burst.querySelector('svg.plectrum-burst-svg');

    var cleaned = false;
    function cleanup() {
      if (cleaned) return;
      cleaned = true;
      try { anime.remove(svg); } catch (e) {}
      if (burst && burst.parentNode) burst.parentNode.removeChild(burst);
    }

    anime({
      targets: svg,
      scale: 4,
      opacity: 0,
      rotate: 35,
      duration: DURATION,
      delay: HOVER_DELAY,
      easing: 'easeOutSine',
      complete: cleanup
    });

    setTimeout(cleanup, HOVER_DELAY + DURATION + 250);
  }

  image.addEventListener('mouseenter', function () {
    spawnHoverSingle();
  });

  var nextElementClasses = item.nextElementSibling && item.nextElementSibling.classList;

  if (nextElementClasses) {
    if (
      nextElementClasses.contains('has-light-to-white-gradient-background') ||
      nextElementClasses.contains('has-light-background-color')
    ) item.classList.add('before-background-light');

    if (nextElementClasses.contains('has-primary-background-color'))
      item.classList.add('before-background-primary');

    if (nextElementClasses.contains('has-dark-background-color'))
      item.classList.add('before-background-dark');
  }
});
